import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { Constants } from 'src/app/models/constants';
import { QRButton } from 'src/app/models/qr-button.model';
import { QRDropdown } from 'src/app/models/qr-dropdown.model';
import { QRIcon } from 'src/app/models/qr-icon.model';

@Component({
  selector: 'qr-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
})
export class DropdownComponent {
  @Input() config!: QRDropdown;
  @Input() selected: string | string[] | undefined;
  @Input() isDisabled?: boolean = false;
  @Input() hasError?: boolean = false;
  @ViewChild('matSelect') matSelect: any;
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  @Output() blurChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  readonly ARROW_DROP_DOWN = Constants.ICONS.ARROW_DROP_DOWN;

  button32pxHierarchy1: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_SMALL,
    viewValue: 'Aplicar',
  };

  isApply = false;

  open(): void {
    if (!this.isDisabled) {
      this.matSelect.trigger.nativeElement.click();
    }
  }

  selectChange(): void {
    if (!this.config.buttonEnd) {
      this.change.emit(this.selected);
    }
  }

  getOptionImage(option: string | string[] | undefined): string | undefined {
    if (typeof option !== 'string') {
      return undefined;
    }
    return this.config.optionImages?.[option];
  }

  getArrowColor(): string {
    let color: string = QRIcon.COLOR_GREY_700;
    if (this.isDisabled) {
      color = QRIcon.COLOR_GREY_400;
    }
    if (this.hasError) {
      color = QRIcon.COLOR_ERROR_900;
    }
    if (!this.hasError && !this.isDisabled) {
      color = QRIcon.COLOR_GREY_700;
    }
    return color;
  }

  buttonClick() {
    this.isApply = true;
    const item = {
      selection: this.selected,
      isApply: true,
    };
    this.change.emit(item);
    this.isApply = false;
    this.matSelect.trigger.nativeElement.click();
  }

  openedChange($event: any) {
    if (this.config.buttonEnd) {
      if (!$event && !this.isApply) {
        const item = {
          isApply: false,
        };
        this.change.emit(item);
      }
    }
  }
}
